import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import 'dayjs/locale/en-ca'
import { TORONTO_TIMEZONE } from '@/constants/time'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('en-ca')

// Set Toronto as default timezone
dayjs.tz.setDefault(TORONTO_TIMEZONE)

// Additional safeguards for timezone handling
if (typeof window !== 'undefined') {
  // Ensure consistent timezone handling in browser environment
  try {
    // Test timezone functionality
    const testDate = dayjs().tz(TORONTO_TIMEZONE)
    if (!testDate.isValid()) {
      console.warn('Timezone configuration might have issues')
    }
  } catch (error) {
    console.error('Error initializing timezone configuration:', error)
  }
}

export default dayjs
